import React from "react";

const LeadSuccess = () => {
    return <div>Success</div>;
};

export default LeadSuccess;
